import { Text } from "@mantine/core";
import { DateInput } from "@mantine/dates";
import { IconX } from "@tabler/icons-react";
import { useCallback } from "react";

import { Flex } from "../../../styled";
import { Button } from "../Button/Button";

export type DateRange = [string | null, string | null];

interface Props {
  dateRange: DateRange;
  setDateRange: (dateRange: DateRange) => void;
}
const DateRangeSelect = ({ dateRange, setDateRange }: Props) => {
  const [startDate, endDate] = dateRange;
  const handleClear = () => {
    setDateRange([null, null]);
  };

  const formatDate = useCallback((date: Date | null) => {
    if (!date) return null;
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  }, []);

  const parseValue = (dateStr: string | null) =>
    dateStr ? new Date(dateStr) : null;

  const setDate = (index: number, date: Date | null) => {
    const newDateRange = [...dateRange];
    newDateRange[index] = formatDate(date);
    setDateRange(newDateRange as DateRange);
  };
  return (
    <Flex gap={5} align="center" ml={10}>
      <Text size="sm">From</Text>
      <DateInput
        value={parseValue(startDate)}
        onChange={v => setDate(0, v)}
        placeholder="Start Date"
        valueFormat="YYYY-MM-DD"
        maw={100}
      />
      <Text size="sm">To</Text>
      <DateInput
        value={parseValue(endDate)}
        onChange={v => setDate(1, v)}
        placeholder="End Date"
        valueFormat="YYYY-MM-DD"
        maw={100}
      />
      {startDate || endDate ? (
        <Button onClick={handleClear} variant="outline" w={30} h={30} p={0}>
          <IconX size={20} />
        </Button>
      ) : (
        <div style={{ width: 30, height: 30 }}></div>
      )}
    </Flex>
  );
};
export default DateRangeSelect;
